module.exports = {"371727001":"天中街道","371727002":"滨河街道","371727101":"陈集镇","371727102":"冉固镇","371727103":"张湾镇","371727104":"黄店镇","371727105":"孟海镇","371727106":"马集镇","371727107":"仿山镇","371727108":"半堤镇","371727109":"杜堂镇","371727110":"南王店镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371727.json
// module id = 1509
// module chunks = 0